module.exports = __webpack_public_path__ + "img/fpz.e2fb5830.png";